import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let echoInstance = null;

export function getEcho() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  if (!echoInstance) {
    echoInstance = new Echo({
      broadcaster:  'pusher',
      key:          '6fedb8863d66bca87fce',
      cluster:      'ap2',
      forceTLS:     true,
      authEndpoint: 'https://tumatrack-api.onrender.com/api/broadcasting/auth',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept:        'application/json',
        },
      },
    });
    window.Echo = echoInstance; // ← expose for debugging
  }

  return echoInstance;
}

export function resetEcho() {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}

export function disconnectEcho() {
  resetEcho();
}